export default {
  wbl: {
    category: "Danh sách danh mục WBL",
    create: "Tạo mới White Black List",
    id: "Id",
    list: "Danh sách White Black",
    title: "Danh sách White/Black",
    update: "Cập nhật White Black List",
    value_list: "Danh sách giá trị",
    wbl_category: "Danh mục White/Black",
  },
}